import "./econsentform.scss";
import { useState, useEffect } from "react";
import { db, storage } from "../../firebase";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import {
  addDoc,
  collection,
  onSnapshot,
  serverTimestamp,
} from "firebase/firestore";
import { useParams } from "react-router-dom";

const initialState = {
  title: "",
};

const EConsentForm = () => {
  const [data, setData] = useState(initialState);
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(null);
  const [filesData, setFilesData] = useState([]);

  useEffect(() => {
    const uploadFile = () => {
      const name = new Date().getTime + file.name;
      const storageRef = ref(storage, file.name);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setProgress(progress);
          switch (snapshot.state) {
            case "paused":
              break;
            case "running":
            default:
              break;
          }
        },
        (error) => {
          console.log(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            setData((prev) => ({ ...prev, consentForm: downloadURL }));
          });
        }
      );
    };

    file && uploadFile();
  }, [file]);

  const { userId } = useParams();

  const collectionRef = collection(db, "greenleaf/" + userId, "consentform");

  // Add Task Handler
  const submitTask = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collectionRef, {
        ...data,
        timeStamp: serverTimestamp(),
      });
      window.location.reload();
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    const unsub = onSnapshot(
      collectionRef,
      (snapshot) => {
        let list = [];
        snapshot.docs.forEach((doc) => {
          list.push({ id: doc.id, ...doc.data() });
        });
        setFilesData(list);
      },
      (error) => {
        console.log(error);
      }
    );

    return () => {
      unsub();
    };
  }, []);

  return (
    <>
      <div className="consentForm">
        <p>View Consent Form</p>
        <hr />

        {/* Modal Button */}
        <button
          type="button"
          class="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#uploadConsentForm"
        >
          Import Consent
        </button>
        <br />
        <br />

        {filesData &&
          filesData.map((item) => (
            <div key={item.id}>
              <iframe
                src={item.consentForm}
                frameborder="0"
                height="700px"
                width="100%"
              ></iframe>
              <p>{item.title}</p>
            </div>
          ))}

        {/* Ending Div */}
      </div>

      {/* Modal */}
      <div
        className="modal fade"
        id="uploadConsentForm"
        tabindex="-1"
        aria-labelledby="uploadConsentFormLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <form className="d-flex" onSubmit={submitTask}>
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="uploadConsentFormLabel">
                  CONSENT FORM
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="enter title here"
                    onChange={handleChange}
                    name="title"
                    value={initialState.name}
                    autoFocus
                  />

                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) => setFile(e.target.files[0])}
                  />
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={progress !== null && progress < 100}
                >
                  Add FILE
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EConsentForm;
